import React, { useState } from 'react';
import { Modal, Button, Form, Row, Col, Card } from 'react-bootstrap';
import { useTheme } from '../../contexts/ThemeContext';
import CustomIcon from '../UI/CustomIcon';

const CustomColorPicker = ({ show, onHide }) => {
  const { 
    customColors, 
    updateCustomColors, 
    resetCustomColors,
    currentTheme 
  } = useTheme();

  const [colors, setColors] = useState(customColors);

  const colorFields = [
    { key: 'primary', label: 'Primary', description: 'Main brand color' },
    { key: 'secondary', label: 'Secondary', description: 'Secondary actions' },
    { key: 'success', label: 'Success', description: 'Success states' },
    { key: 'danger', label: 'Danger', description: 'Error states' },
    { key: 'warning', label: 'Warning', description: 'Warning states' },
    { key: 'info', label: 'Info', description: 'Information states' },
    { key: 'background', label: 'Background', description: 'Page background' },
    { key: 'surface', label: 'Surface', description: 'Card/surface background' },
    { key: 'text', label: 'Text', description: 'Primary text color' },
    { key: 'textSecondary', label: 'Text Secondary', description: 'Secondary text color' },
    { key: 'border', label: 'Border', description: 'Border color' },
  ];

  const handleColorChange = (key, value) => {
    setColors(prev => ({ ...prev, [key]: value }));
  };

  const handleSave = () => {
    updateCustomColors(colors);
    onHide();
  };

  const handleReset = () => {
    setColors(resetCustomColors());
  };

  const handleCancel = () => {
    setColors(customColors);
    onHide();
  };

  if (currentTheme !== 'custom') {
    return null;
  }

  return (
    <Modal show={show} onHide={handleCancel} size="lg">
      <Modal.Header closeButton>
        <Modal.Title className="d-flex align-items-center">
          <CustomIcon name="settings" size={20} className="me-2" />
          Custom Theme Colors
        </Modal.Title>
      </Modal.Header>
      
      <Modal.Body>
        <Row>
          {colorFields.map((field) => (
            <Col md={6} lg={4} key={field.key} className="mb-3">
              <Card className="h-100">
                <Card.Body className="p-3">
                  <Form.Group>
                    <Form.Label className="fw-bold">
                      {field.label}
                    </Form.Label>
                    <div className="d-flex align-items-center">
                      <Form.Control
                        type="color"
                        value={colors[field.key]}
                        onChange={(e) => handleColorChange(field.key, e.target.value)}
                        className="me-2"
                        style={{ width: '50px', height: '38px' }}
                      />
                      <Form.Control
                        type="text"
                        value={colors[field.key]}
                        onChange={(e) => handleColorChange(field.key, e.target.value)}
                        placeholder="#000000"
                        style={{ fontFamily: 'monospace' }}
                      />
                    </div>
                    <Form.Text className="text-muted">
                      {field.description}
                    </Form.Text>
                  </Form.Group>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Modal.Body>
      
      <Modal.Footer>
        <Button variant="outline-secondary" onClick={handleReset}>
          Reset to Default
        </Button>
        <Button variant="outline-secondary" onClick={handleCancel}>
          Cancel
        </Button>
        <Button variant="primary" onClick={handleSave}>
          Save Colors
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CustomColorPicker;
